import { AnalyticsEvent } from './analytics-event';
import { ItemEvent, ListEvent, SectionEvent } from './event-context';
import {
  ListBuildingAction,
  ListBuildingItemAction,
  ListBuildingListAction,
  ListBuildingSectionAction,
} from './list-building-action';

export const LIST_BUILDING_EVENT_CLASS = 'list.edit';
type ListBuildingEventClass = typeof LIST_BUILDING_EVENT_CLASS;

export enum ListBuildingActionTarget {
  LIST = 'list',
  SECTION = 'section',
  ITEM = 'item',
  RESOURCE = 'resource',
}

export interface ListBuildingEventProps extends ListEvent {
  action_target: ListBuildingActionTarget;
  action_type: ListBuildingAction;
  [key: string]: any;
}

export interface ListBuildingEvent extends AnalyticsEvent {
  className: ListBuildingEventClass;
  props: ListBuildingEventProps;
}

export interface ListBuildingListEventProps
  extends ListBuildingEventProps,
    ListEvent {
  action_target: ListBuildingActionTarget.LIST;
  action_type: ListBuildingListAction;
}

export interface ListBuildingListEvent extends ListBuildingEvent {
  props: ListBuildingListEventProps;
}

export interface ListBuildingSectionEventProps
  extends ListBuildingEventProps,
    SectionEvent {
  action_target: ListBuildingActionTarget.SECTION;
  action_type: ListBuildingSectionAction;
}

export interface ListBuildingSectionEvent extends ListBuildingEvent {
  props: ListBuildingSectionEventProps;
}

export interface ListBuildingItemEventProps
  extends ListBuildingEventProps,
    ItemEvent {
  action_target: ListBuildingActionTarget.ITEM;
  action_type: ListBuildingItemAction;
}

export interface ListBuildingItemEvent extends ListBuildingEvent {
  props: ListBuildingItemEventProps;
}

export function createListBuildingEventForList(
  listId: string,
  action: ListBuildingListAction,
  additionalProps: { [key: string]: any } = {},
): ListBuildingListEvent {
  return {
    className: LIST_BUILDING_EVENT_CLASS,
    props: {
      action_target: ListBuildingActionTarget.LIST,
      action_type: action,
      list_id: listId,
      ...additionalProps,
    },
  };
}

export function createListBuildingEventForSection(
  listId: string,
  sectionId: string,
  action: ListBuildingSectionAction,
  additionalProps: { [key: string]: any } = {},
): ListBuildingSectionEvent {
  return {
    className: LIST_BUILDING_EVENT_CLASS,
    props: {
      action_target: ListBuildingActionTarget.SECTION,
      action_type: action,
      list_id: listId,
      section_id: sectionId,
      ...additionalProps,
    },
  };
}

export function createListBuildingEventForItem(
  listId: string,
  itemId: string,
  action: ListBuildingItemAction,
  additionalProps: { [key: string]: any } = {},
): ListBuildingItemEvent {
  return {
    className: LIST_BUILDING_EVENT_CLASS,
    props: {
      action_target: ListBuildingActionTarget.ITEM,
      action_type: action,
      list_id: listId,
      item_id: itemId,
      ...additionalProps,
    },
  };
}
